import React from 'react';
import SensorDashboard from '../components/SensorDashboard';

const Home = () => {
  return <SensorDashboard />;
};

export default Home;
